<p-tabpanel [value]="value()">
  @if (loading()) {
    <app-loading />
  } @else {
    <ng-content />
  }
</p-tabpanel>
